export const getDeliverySelectedDate = (interval = []) => {
  const { dateFrom, dateTo } = interval.find(({ time }) => time.some(({ selected }) => selected)) || {};
  return {
    dateFrom,
    dateTo,
  };
};
